/**
 * The assistant's two marks. Shared rather than exported from the panel, which would put the
 * panel and the message bubble in an import cycle.
 *
 * `ORB` is a full-colour illustration and must never be given a `fill` — it carries its own
 * gradient. `SPARK` is a single-colour glyph on `currentColor`, so it takes the button's variant
 * colour the way every other kit icon does.
 */
/* A name of its own for the indigo orb, not the old file's: the blue one was served from the same
   path without a Cache-Control header, so browsers that had seen it kept it for hours on their own
   reckoning. A new path cannot be stale. */
export const ASSISTANT_ORB = "/media/svg/popleads/ai_assistant_orb_l3rn.svg";
export const ASSISTANT_SPARK = "/media/svg/popleads/ai_spark.svg";

/**
 * The archive glyph. Stroked on `currentColor` like the other header icons, rather than filled like
 * `SPARK` — it sits beside the feather-drawn close and refresh icons and has to match their weight.
 */
export const ASSISTANT_ARCHIVE = "/media/svg/popleads/ai_archive.svg";
